(function (window, document) {
    if (document.querySelector('.event-slider') !== null) {
        var categorySelectElement = document.querySelector('.event-slider .eventlist-eventselect');
        var categorySelectElementMobil = document.querySelector('.event-slider .eventlist-filterselect');
        var loading = false;

        /**
         * Load event
         *
         * @param categoryId
         */
        function loadEvents(categoryId) {
            if (loading) {
                return;
            }
            loading = true;

            var category = (categoryId && categoryId !== null) ? categoryId : '';
            var url = window._AVENCY_BASE_actions.eventSlider;
            url += category !== '' ? '&category=' + category : '';

            var request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.onload = function () {
                if (this.status >= 200 && this.status < 400 && this.response != '') {
                    document.querySelector('.event-slider .eventlist-slider').innerHTML = this.response;

                    addSlickSlider();

                    loading = false;
                }
            };
            request.send();
        }

        // Load first batch of event
        loadEvents();

        if (categorySelectElement !== null) {
            categorySelectElement.addEventListener('click', function (e) {
                var activeElement = $(e.target).closest('li');
                var categoryId = activeElement[0].dataset.categoryid;

                var filterOptions = categorySelectElement.querySelectorAll('li');
                Array.prototype.forEach.call(filterOptions, function (el) {
                    el.classList.remove('active');
                });
                activeElement[0].classList.add('active');

                if (categorySelectElementMobil !== null) {
                    var selectOptions = categorySelectElementMobil.parentNode.querySelector('.select-items').querySelectorAll('div');
                    Array.prototype.forEach.call(selectOptions, function (el) {
                        el.classList.remove('same-as-selected');

                        if (el.innerHTML.toUpperCase() == activeElement[0].innerText) {
                            el.classList.add('same-as-selected');
                            categorySelectElementMobil.parentNode.querySelector('.select-selected').innerHTML = el.innerHTML;
                        }
                    });
                }

                loading = false;
                loadEvents(categoryId);
            });
        }

        if (categorySelectElementMobil !== null) {
            categorySelectElementMobil.addEventListener('change', function (e) {
                var activeElement = $(e.target).parent().find('.same-as-selected');
                var categoryId = activeElement[0].getAttribute('value');

                if (categorySelectElement !== null) {
                    var filterOptions = categorySelectElement.querySelectorAll('li');
                    Array.prototype.forEach.call(filterOptions, function (el) {
                        el.classList.remove('active');

                        if(el.innerText == activeElement[0].innerText) {
                            el.classList.add('active');
                        }
                    });
                }

                loading = false;
                loadEvents(categoryId);
            });
        }

        /**
         * Add slick slider
         */
        function addSlickSlider() {
            $('.event-slider .eventlist-slider .slider').slick({
                infinite: false,
                slidesToShow: 2,
                prevArrow: $('.slick-prev'),
                nextArrow: $('.slick-next'),
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });

            var cardGroup = $('.event-slider .eventlist-slider .card-group');
            Array.prototype.forEach.call(cardGroup, function (el) {
                el.classList.remove('col-md-4');
            });
        }
    }
})(window, document);
